import { Component } from '@angular/core';

@Component({
  selector: 'app-platinum-brochure',
  templateUrl: './platinum-brochure.component.html',
  styleUrls: ['./platinum-brochure.component.scss']
})
export class PlatinumBrochureComponent {

}
